module.exports = __webpack_public_path__ + "media/images/kvimg_2pc-77cff186da7663efc3b4de2b6f090ff1.jpg";